var hasAcceptedFunctional = function () {
    return ICF.Utils.Consent.CookieContainsPattern(ICF.Variables.ConsentGroupPatterns.AcceptedFunctional)
};

module.exports = hasAcceptedFunctional;